export const projectsData = [
    {
        id: 1,
        projectName: 'Faballey',
        projectDesc: 'FabAlley is an online fashion store.',
        tags: ["React", "Node.js", "MongoDb", "Express", "Tailwind"],
        logos: ["fab fa-react", "fab fa-etsy", "fab fa-node", "fas fa-database", "fab fa-etsy"],
        code: 'https://github.com/Sachi4496/faballey-clone.git',
        demo: 'https://faballey-clone.vercel.app/',
        image: "https://user-images.githubusercontent.com/53556482/153560974-2ee2f508-b57a-4af8-87be-17139579613d.png"
    },
    {
        id: 2,
        projectName: 'Udemy',
        projectDesc: 'Udemy is an E-learning web application for online learning and teaching.',
        // tags: ["React", "Node.js", "MongoDb"],
        //  logos: ["fab fa-react","fab fa-etsy","fab fa-node","fas fa-database"],
        tags: ["EJS", "Node.js", "mongoDB", "Express"],
        logos: ["fab fa-vuejs", "fas fa-database", "fab fa-js", "fab fa-node", "fab fa-etsy"],
        code: 'https://github.com/Sachi4496/Udemy-Clone-Backend.git',
        demo: 'https://aqueous-fortress-78543.herokuapp.com/',
        image: "https://user-images.githubusercontent.com/91539305/147107410-e2cf1961-f777-4e33-8a49-586a9a612cb5.gif"
    },
    {
        id: 2,
        projectName: 'Udemy',
        projectDesc: 'Udemy is an E-learning web application for online learning and teaching.',
        tags: ["Html", "Tailwind", "javascript", "Mock Server"],
        logos: ["fab fa-html5", "fab fa-css3", "fab fa-js", "fab fa-etsy"],
        code: 'https://github.com/Sachi4496/udemy-clone.git',
        demo: 'https://aqueous-fortress-78543.herokuapp.com/',
        image: "https://user-images.githubusercontent.com/91539305/147107410-e2cf1961-f777-4e33-8a49-586a9a612cb5.gif"
    },
    {
        id: 3,
        projectName: 'MedPlusMart',
        projectDesc: 'MedPlus is the second largest pharmacy chain in India.MedPlus sells prescription and OTC medicines, FMCG products, vitamins and other nutrition supplements, and opticals.',
        tags: ["Html", "css", "javascript"],
        logos: ["fab fa-html5", "fab fa-css3", "fab fa-js"],
        code: 'https://github.com/Sachi4496/medPlus_mart.git',
        demo: 'https://sachi4496.github.io/medPlus_mart/',
        image: "https://user-images.githubusercontent.com/53556482/140514171-158de03b-65ae-4cd0-9bef-c7f2846fae21.png"
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/